// import node module libraries
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  colorPalette: [
    "#2ecc71",
    "#e74c3c",
    "#3498db",
    "#f1c40f",
    "#9b59b6",
    "#1abc9c",
    "#e67e22",
    "#34495e",
  ],
  selectedPalette: "default",
};

const colorPaletteSlice = createSlice({
  name: "colorPalette",
  initialState,
  reducers: {
    setSelectedPalette(state, action) {
      const { colorPalette, selectedPalette } = action.payload;
      state.colorPalette = colorPalette;
      state.selectedPalette = selectedPalette;
    },
    forceUpdatePalette(state) {
      // This will trigger a re-render by creating a new array reference
      state.colorPalette = [...state.colorPalette];
    },
  },
});

export const { setSelectedPalette, forceUpdatePalette } =
  colorPaletteSlice.actions;

export default colorPaletteSlice.reducer;
